import type { ReactNode } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';

export const CASE_MANAGEMENT_FONT_FAMILY =
  '"Roboto", "Helvetica", "Arial", sans-serif';

const caseManagementTheme = createTheme({
  typography: {
    fontFamily: CASE_MANAGEMENT_FONT_FAMILY,
    htmlFontSize: 12.4444444,
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: CASE_MANAGEMENT_FONT_FAMILY,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: CASE_MANAGEMENT_FONT_FAMILY,
          letterSpacing: 0,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: CASE_MANAGEMENT_FONT_FAMILY,
        },
        input: {
          fontFamily: 'inherit',
          fontSize: 'inherit',
          lineHeight: 'inherit',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: CASE_MANAGEMENT_FONT_FAMILY,
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontFamily: CASE_MANAGEMENT_FONT_FAMILY,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily: CASE_MANAGEMENT_FONT_FAMILY,
          lineHeight: 1.43,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontFamily: CASE_MANAGEMENT_FONT_FAMILY,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: CASE_MANAGEMENT_FONT_FAMILY,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontFamily: CASE_MANAGEMENT_FONT_FAMILY,
        },
      },
    },
  },
});

type CaseManagementStyleProviderProps = {
  children: ReactNode;
};

export function CaseManagementStyleProvider({
  children,
}: CaseManagementStyleProviderProps) {
  return (
    <ThemeProvider theme={caseManagementTheme}>
      <div className='case-management-mui'>{children}</div>
    </ThemeProvider>
  );
}
